"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var file_1 = __importDefault(require("relements/build/esm/input/file"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var constants_1 = require("../../constants");
require("./TaskHeader.scss");
var TaskHeader = function (_a) {
    var taskId = _a.taskId, taskActive = _a.taskActive, taskTitle = _a.taskTitle, userSays = _a.userSays, taskIndex = _a.taskIndex, imageURL = _a.imageURL, expandIcon = _a.expandIcon, sortableHandle = _a.sortableHandle, handleActiveChange = _a.handleActiveChange, toggleTransferModal = _a.toggleTransferModal, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (react_1["default"].createElement("div", { className: "taskHeader" },
        react_1["default"].createElement(checkbox_1["default"].Item, { className: "taskHeaderCheckbox", value: taskActive, disabled: disabled, onChange: function (value, e) {
                e.stopPropagation();
                handleActiveChange(constants_1.TASKBOX_KEYS.TASK_ACTIVE, value, taskIndex, true);
            } }),
        react_1["default"].createElement(file_1["default"], { onChange: function (newImageURL, e) {
                e === null || e === void 0 ? void 0 : e.stopPropagation();
                handleActiveChange(constants_1.TASKBOX_KEYS.TASK_IMAGE, newImageURL, taskIndex, true);
            }, maxFileSize: 1 }, function (uploads, renderInput) {
            var upload = uploads && uploads[0];
            var inProgressImage = '';
            var imageProgress = 0;
            var uploadingClassName = '';
            if (upload) {
                inProgressImage = upload.previewURL;
                imageProgress = upload.isUploading && upload.uploadedPercent;
                uploadingClassName = upload.isUploading && 'uploading';
            }
            return (react_1["default"].createElement("div", { className: "taskHeaderIcon" },
                inProgressImage || imageURL ? (react_1["default"].createElement("img", { className: "taskHeaderIconImage " + uploadingClassName, src: inProgressImage || imageURL, alt: "taskImg" })) : (react_1["default"].createElement(icon_1["default"], { src: "task", className: "taskHeaderIconImage greyIcon " + uploadingClassName })),
                renderInput(),
                !!imageProgress && imageProgress < 100 && (react_1["default"].createElement("div", { className: "taskHeaderIconLoader" },
                    react_1["default"].createElement(loader_1["default"], null)))));
        }),
        react_1["default"].createElement("div", { className: "taskHeaderTitle" }, taskTitle),
        react_1["default"].createElement("div", { className: "taskHeaderUserSays" }, userSays),
        react_1["default"].createElement("div", { className: "taskHeaderCtas" },
            react_1["default"].createElement("span", null, taskId),
            react_1["default"].createElement(icon_1["default"], { src: "transfer", onClick: function (e) {
                    e.stopPropagation();
                    toggleTransferModal(taskId);
                }, className: "taskHeaderCta transferIcon" }),
            sortableHandle,
            expandIcon)));
};
exports["default"] = TaskHeader;
